
<script setup lang="ts">
import { watch, defineProps, defineEmits } from "vue";
import { type CurrencyInputOptions, useCurrencyInput } from "vue-currency-input";

const props = defineProps({
  modelValue: Number,
  inputName: {
    type: String,
    default: null
  },
  inputClass: {
    type: String,
    default: ''
  },
  currency: {
    type: String,
    default: 'USD'
  },
  id: {
    type: String,
    default: undefined
  },
  precision: {
    type: [Number, Object],
    default: 2
  },
  locale: {
    type: String,
    default: undefined
  },
  withDiscard: {
    type: Boolean,
    default: false
  },
})
const locale = props.locale ?? window.Laravel.locale;


const emits = defineEmits([
  'update:modelValue',
  'discard'
])

const onDiscard = () => {
  emits('discard')
}

const { inputRef, numberValue, setValue } = useCurrencyInput(<CurrencyInputOptions>{
  locale: locale,
  currency: props.currency,
  currencyDisplay: "hidden",
  precision: props.precision,
  hideCurrencySymbolOnFocus: true,
  hideGroupingSeparatorOnFocus: true,
  hideNegligibleDecimalDigitsOnFocus: true,
  autoDecimalDigits: false,
  useGrouping: true,
  accountingSign: false
})

watch(
  () => props.modelValue, // Vue 2: props.value
  (value) => {
    if (value === null || value === undefined) {
      return
    }
    setValue(value)
  }
)


</script>
<template>
  <div class="input-group">
    <div class="input-group-prepend">
      <span class="input-group-text">{{ currency }}</span>
    </div>
    <input
      v-if="inputName"
      :name="inputName"
      type="hidden"
      :value="numberValue"
    >
    <input
      type="text"
      inputmode="numeric"
      ref="inputRef"
      :id="id"
      :class="['form-control input-price', inputClass]"
    />
    <div class="input-group-append" v-if="withDiscard">
      <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="onDiscard">
        <i class="fa fa-times-circle" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</template>
